<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1 class="mb-4">
          {{ $tc('models.country', 2) }}
          <v-btn color="primary" @click="goTo('newCountry')"> {{ $t('create') }} </v-btn>
        </h1>

        <v-data-table class="elevation-1 mt-5"
                      :headers="headers"
                      :items="items"
                      :loading="loading"
                      :no-data-text="$t('noDataAvailable')">
          <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
          <template v-slot:items="props">
            <td> {{ props.item.id }} </td>
            <td> {{ props.item.name }} </td>
            <td class="pa-0 pr-2 text-xs-right">
              <v-btn color="primary" flat icon @click="goTo('editCountry', props.item.id)">
                <font-awesome-icon icon="edit"></font-awesome-icon>
              </v-btn>

              <v-btn color="primary" flat @click="goTo('states', { countryId: props.item.id })">
                {{ $tc('models.state', 2) }}
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Country from '@/client/country'

export default {
  name: 'CountriesView',

  props: {},

  data () {
    return {
      headers: [
        { text: '#', align: 'left', sortable: true, value: 'id', width: '5%' },
        { text: this.$t('attrs.name'), align: 'left', sortable: true, value: 'name' },
        { text: '', align: 'left', sortable: false, value: '' }
      ],
      items: [],
      loading: false,
      pagination: {
        rowsPerPage: 10,
        sortBy: 'name',
        descending: false
      }
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    async fetch () {
      this.loading = true
      this.items = await Country.all({
        order: `countries.name asc`,
        per_page: 2000
      })
      this.loading = false
    }
  },

  watch: {
  },

  async mounted () {
    this.fetch()
  }
}
</script>
